import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API, ADMIN_TOKEN_KEY, errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export const AdminLogin = ({ onDone }) => {
  const [f, setF] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, f);
      localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dot-bg" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 rounded-3xl border border-slate-200 bg-white p-8 shadow-xl" data-testid="admin-login-form">
        <Logo small />
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-bold"><Lock className="h-5 w-5 text-teal-600" />Clinic admin</h1>
          <p className="mt-1 text-sm text-slate-500">Sign in to manage bookings, reviews and the website.</p>
        </div>
        <div><Label htmlFor="admin-id">Admin ID</Label>
          <Input id="admin-id" className="mt-2 h-11" autoComplete="username" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} data-testid="admin-login-username" /></div>
        <div><Label htmlFor="admin-pw">Password</Label>
          <Input id="admin-pw" type="password" className="mt-2 h-11" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-login-password" /></div>
        <button disabled={busy || !f.username || !f.password} data-testid="admin-login-submit"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-teal-600 py-3 font-bold text-white disabled:opacity-50">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Sign in</button>
        <p className="text-center text-xs text-slate-500">Owner with Google access? <Link to="/sign-in" className="font-bold text-teal-700 underline" data-testid="admin-login-google-link">Sign in with Google</Link></p>
      </form>
    </div>
  );
};
